import {mapGetters, mapMutations} from "vuex";
import {POPUP_TEXT_CONTENT,} from '@/store/mutation-types'


export default {
    name: 'thanks',
    computed: {
        ...mapGetters({
            popup: 'system/popup',
        })
    },
    methods: {
        ...mapMutations({
            changeContent: `system/${POPUP_TEXT_CONTENT}`,
        })
    },
    destroyed() {
        this.changeContent({title: '', text: ''});
    }
}
